type Props = {
    canLogOffline: boolean;
    onLogOffline: () => void;
};

const MentorSessionsHeader = ({ canLogOffline, onLogOffline }: Props) => (
    <div className="d-flex flex-wrap align-items-start justify-content-between mb-4 gap-3">
        <div>
            <h4 className="font-22 font-600 mb-1 text-dark">Sessions &amp; Scheduling</h4>
            <div className="text-secondary small">
                Set your recurring availability. Availability saves now. Booking arrives with the mentee portal.
            </div>
        </div>
        <div className="d-flex gap-2">
            {canLogOffline ? (
                <button type="button" className="btn btn-sm btn-outline-secondary font-500 rounded-pill px-3" onClick={onLogOffline}>
                    📋 Log Offline Session
                </button>
            ) : null}
            <button
                type="button"
                className="btn btn-sm btn-primary font-500 rounded-pill px-3"
                disabled
                title="Available when mentees can book"
            >
                + Propose Session
            </button>
        </div>
    </div>
);

export default MentorSessionsHeader;
